import Cookies from "js-cookie";
import axios from "axios";

const regenerateToken = async () => {
  // Regeneration of Token
  const refreshToken = Cookies.get("refreshToken");
  const requestBody = {
    refresh_token: refreshToken,
  };
  const regenerateConfig = {
    method: "POST",
    url: "https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing/oauth/token?grant_type=refresh_token",
    data: JSON.stringify(requestBody),
  };
  try {
    const regenerateTokenResponse = await axios(regenerateConfig);
    console.log("regenerateTokenResponse", regenerateTokenResponse);
    const newIdToken = regenerateTokenResponse.data.data.IdToken;
    Cookies.set("idToken", newIdToken, {
      expires: 1,
    });
    localStorage.setItem("idTokenBilling", newIdToken);
    return newIdToken;
  } catch (e) {
    console.log("error in regenerating Token", e.message);
    throw e;
  }
};

export default regenerateToken;
